import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

const handleLogout = () => {
    localStorage.removeItem('currentUser')
    localStorage.removeItem('token')
    localStorage.removeItem('tabIndex')
    localStorage.clear();
    // Redirect to login page
    window.location.href = '/';
};

function storeToken(token) {
    localStorage.setItem("token", token);
}

// Create an Axios instance
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor
api.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');

        // If the token exists, add it to the headers
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);

const handle401Error = (error) => {
    if (error.response && error.response.status === 401) {
        handleLogout();
    }
    return Promise.reject(error);
};

// Add response interceptor to api instance
api.interceptors.response.use(
    (response) => response,
    handle401Error
);

const api1 = axios.create({
    baseURL: BASE_URL,
 
});

// Add a request interceptor
api1.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');

        // If the token exists, add it to the headers
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);

api1.interceptors.response.use(
    (response) => response,
    handle401Error
);

const SignUpHandler = {

    async doHanderSignUp(payload, options = {}) {
        try {
            const { data } = await axios.post(`${BASE_URL}auth/register`, payload);
            return data;
        } catch (error) {
            return error;
        }
    },

    async doHandlerGoogleLogin(payload) {
        try {
            const { data } = await axios.post(`${BASE_URL}auth/signin/google`, payload);
            // console.log(data,'data on google')
            storeToken(data?.data?.token);
            return data;
        } catch (error) {
            return error
        }
    },
    async doHandlerAppleLogin(payload) {
        try {
            // console.log(payload, 'payload at time of api function call')
            const { data } = await axios.post(`${BASE_URL}auth/signin/apple`, payload);
            // console.log(data, 'data')
            storeToken(data?.data?.token);
            // localStorage.setItem('currentUser', JSON.stringify(data?.data?.user));
            return data;
        } catch (error) {
            return error
        }
    },

    async doHandlerOtpSubmit(payload) {
        try {
            const { data } = await api.post(`${BASE_URL}auth/checkOtp`, payload);
            return data;
        } catch (error) {
            return error
        }
    },

    async doHandlerResendOtpSubmit() {
        try {
            const { data } = await api.get(`${BASE_URL}auth/resend-otp`);
            return data;
        } catch (error) {
            return error
        }
    },



    // PHP

    // async doEncriptions(payload) {
    //     try {
    //         const { data } = await axios.post(`https://payment.techiezone.fun/api/encryption`, payload,
    //             {
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                 },
    //             }
    //         );
    //         return data;
    //     } catch (error) {
    //         return error

    //     }
    // },

    // async doDecryptions(decryptionData) {
    //     try {

    //         const { data } = await axios.post(`https://payment.techiezone.fun/api/decryption`, decryptionData,
    //             {
    //                 headers: {
    //                     'Content-Type': 'text/plain',
    //                 },
    //             }
    //         );
    //         return data;
    //     } catch (error) {
    //         return error
    //     }
    // },

    // async doMakePayment(encryptionData) {
    //     try {
    //         const { data } = await axios.post(`https://payment.techiezone.fun/api/payment`, encryptionData,
    //             {
    //                 headers: {
    //                     'Content-Type': 'text/plain',
    //                 },
    //             }
    //         )
    //         return data;
    //     } catch (error) {
    //         return error
    //     }
    // },

    async doMakePaymentPremium(formData) {
        try {
            const { data } = await api.post(`${BASE_URL}subscription/webSubscription`, formData)
            return data;
        } catch (error) {
            return error
        }
    },

    async doGetSubscriptionStatus() {
        try {
            const { data } = await api1.get(`${BASE_URL}subscription/subscriptioStatus`)
            return data;

        } catch (error) {
            console.error('Error in doGetSubscriptionStatus:', error);

            return error
        }
    },

    async  doCancelSubscription() {
        try {
            const { data } = await api1.get(`${BASE_URL}subscription/cancelledSubscription`)
            return data;

        } catch (error) {
            console.error('Error in cancelPlan:', error);

            return error
        }
    },

    async  doGetUserSubscriptionDetails() {
        try {
            const { data } = await api1.get(`${BASE_URL}subscription/userPlanDetail`)
            return data;

        } catch (error) {
            console.error('Error in Get Plan Details:', error);

            return error
        }
    }
}




export default SignUpHandler